import FormLayout from 'shared/components/forms/FormLayout';
import FormLayoutGroup from 'shared/components/forms/FormLayoutGroup';
import TextArea from 'shared/components/forms/TextArea';
import {BirthdayPicker} from 'shared/components/forms/birthday_picker';

FormLayout.Group = FormLayoutGroup;

export {
  BirthdayPicker,
  FormLayout,
  TextArea
};
